import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/storage';
import 'firebase/firestore';

const config = {
  apiKey: "AIzaSyBaU_JV5hKZTPM-suQ7ZZnpWuVW3xUG6Dk",
  authDomain: "custombook.firebaseapp.com",
  databaseURL: "https://custombook.firebaseio.com",
  projectId: "custombook",
  storageBucket: "custombook.appspot.com",
  messagingSenderId: "384607754182"
};

export default class Firebase {
  static firebase = null;
  static firestore = null;
  static storage = null;

  static getFirebase() {
      if (Firebase.firebase == null) {
          firebase.initializeApp(config);
          Firebase.firebase = firebase;
      }

      return this.firebase;
  }

  static getFirestore() {
      if (Firebase.firestore == null) {
        var db = this.getFirebase().firestore();
        db.settings({ timestampsInSnapshots: true });
        Firebase.firestore = db;
      }

      return this.firestore;
  }

  static getStorage() {
      if (Firebase.storage == null) {
        var sto = this.getFirebase().storage();
        Firebase.storage = sto;
      }

      return this.storage;
  }
}
